// Custom lazy load
function imagesLoaded()  {
    jQuery(function($) {
        $('.loading img').on('load', function() {
            var el = $(this);

            setTimeout(function() {
                el.parent().removeClass('loading').prev().fadeOut(300);
                el.parent().parent().removeClass('loading').prev().fadeOut(300);
            }, _.random(100, 600) );

            setTimeout(function() {
                el.prev().remove();
            }, 3000);
        });

        $(window).on('load', function() {
            $('span.loader').fadeOut();
        });
    });
}
